import { z } from '@harvestiq/zod';

export const resendVerificationEmailRequestBodySchema = z.object({
  email: z.string().email(),
});
export type ResendVerificationEmailRequestBody = z.infer<
  typeof resendVerificationEmailRequestBodySchema
>;

// No response expected, simply 200 code with 'OK' string content
export const resendVerificationEmailResponseSchema = z.literal('OK');
export type ResendVerificationEmailResponse = z.infer<
  typeof resendVerificationEmailResponseSchema
>;
